/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { ON_KEY_EVENT, ON_MOUSE_EVENT } from './inputfactory.types';

export const onKeyEventAction = (key: string, code: number): AnyAction => ({
    type: ON_KEY_EVENT,
    payload: {
        key,
        code,
    },
});

export const onMouseEventAction = (eventType: string, value: any): AnyAction => ({
    type: ON_MOUSE_EVENT,
    payload: {
        eventType,
        value,
    },
});
